import { Loader2 } from "lucide-react";
export default function LoadingComp() {
  return <div className="relative flex h-[100vh] w-full items-center justify-center" data-sentry-component="LoadingComp" data-sentry-source-file="loading.tsx">
      <Loader2 className="z-10 size-14 animate-spin text-primary" data-sentry-element="Loader2" data-sentry-source-file="loading.tsx" />
      <div className="absolute inset-0 blur-sm"></div>
    </div>;
}